export default "__VITE_ASSET__DHDSlFwD__"